/**
 * font : Roboto Condensed
 * size : 100
 * varient : 700
 * <amaive 는 letterspace 9>
 */

import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import SvgIcon from "@material-ui/core/SvgIcon";
import PropTypes from "prop-types";

const CustomSvgIcon = withStyles({
  root: { width: "inherit", height: "inherit" }
})(SvgIcon);

class TextBrandLogoIcon extends Component {
  static propTypes = {
    style: PropTypes.object
  };

  static defaultProps = {
    style: null
  };

  // // amaive 용 함수.
  // getSvg(style) {
  //   const letterSpace = 9;

  //   return (
  //     <CustomSvgIcon
  //       style={style}
  //       viewBox={`0 0 ${326.465 + letterSpace * 5} 71.094`}
  //     >
  //       <path fill="none" d={`M0 0h${326.465 + letterSpace * 5}v71.094H0z`} />
  //       <path
  //         d={`m42.383,71.094l-3.809,-14.551l-19.58,0l-3.808,14.551l-15.186,0l22.217,-71.094l13.135,0l22.363,71.094l-15.332,0zm-13.623,-51.856l-6.641,25.342l13.281,0l-6.64,-25.342z`}
  //         id="0"
  //       />
  //       <path
  //         d={`m${
  //           64.355 + letterSpace
  //         },0l18.75,0l13.428,51.416l13.379,-51.416l18.75,0l0,71.094l-14.404,0l0,-19.239l1.318,-29.638l-14.209,48.877l-9.765,0l-14.209,-48.877l1.318,29.638l0,19.239l-14.356,0l0,-71.094z`}
  //         id="1"
  //       />
  //       <path
  //         d={`m${
  //           178.809 + letterSpace * 2
  //         },71.094l-3.809,-14.551l-19.58,0l-3.809,14.551l-15.185,0l22.217,-71.094l13.134,0l22.364,71.094l-15.332,0zm-13.623,-51.856l-6.641,25.342l13.281,0l-6.64,-25.342z`}
  //         id="2"
  //       />
  //       <path
  //         d={`m${
  //           215.771 + letterSpace * 3
  //         },0l0,71.094l-14.355,0l0,-71.094l14.355,0z`}
  //         id="3"
  //       />
  //       <path
  //         d={`m${
  //           239.063 + letterSpace * 4
  //         },0l11.914,51.563l11.962,-51.563l16.016,0l-20.508,71.094l-14.941,0l-20.361,-71.094l15.918,0z`}
  //         id="4"
  //       />
  //       <path
  //         d={`m${
  //           322.363 + letterSpace * 5
  //         },28.76l0,11.572l-22.363,0l0,18.848l26.465,0l0,11.914l-40.82,0l0,-71.094l40.722,0l0,11.963l-26.367,0l0,16.797l22.363,0z`}
  //         id="5"
  //       />
  //     </CustomSvgIcon>
  //   );
  // }

  getSvg(style) {
    const letterSpace = 4;

    return (
      <CustomSvgIcon
        style={style}
        viewBox={`0 0 ${470.313 + letterSpace * 6} 72.071`}
      >
        <path fill="none" d={`M0 0h${470.313 + letterSpace * 6}v72.071H0z`} />
        <path
          d={`m0,0l19.141,0l18.261,51.563l18.164,-51.563l19.239,0l0,71.094l-14.698,0l0,-19.434l1.465,-33.545l-19.189,52.979l-10.059,0l-19.14,-52.93l1.464,33.496l0,19.434l-14.648,0l0,-71.094z`}
          id="0"
        />
        <path
          d={`m${
            133.545 + letterSpace
          },71.094l-4.932,-14.649l-25.683,0l-4.883,14.649l-15.576,0l26.465,-71.094l13.574,0l26.611,71.094l-15.576,0zm-17.822,-53.125l-8.838,26.611l17.773,0l-8.935,-26.611z`}
          id="1"
        />
        <path
          d={`m${
            194.043 + letterSpace * 2
          },0l14.697,0l0,46.826q0,11.67 -7.3,18.457a24.377,24.377 0 0 1 -10.861,5.746q-4.132,1.041 -9.085,1.041q-11.078,0 -18.098,-5.218a23.169,23.169 0 0 1 -1.677,-1.373a22.065,22.065 0 0 1 -7.001,-12.945a31.818,31.818 0 0 1 -0.47,-5.171l0,-47.363l14.648,0l0,46.924a23.168,23.168 0 0 0 0.265,3.628q0.676,4.254 3.08,6.552a11.054,11.054 0 0 0 4.952,2.691q1.704,0.444 3.719,0.5a21.135,21.135 0 0 0 0.582,0.008a16.886,16.886 0 0 0 5.049,-0.69q7.35,-2.304 7.5,-12.299l0,-47.314z`}
          id="2"
        />
        <path
          d={`m${
            278.564 + letterSpace * 3
          },0l0,71.094l-14.648,0l-28.516,-46.778l0,46.778l-14.648,0l0,-71.094l14.648,0l28.565,46.875l0,-46.875l14.599,0z`}
          id="3"
        />
        <path
          d={`m${
            334.131 + letterSpace * 4
          },28.809l0,11.474l-28.125,0l0,19.043l33.008,0l0,11.768l-47.657,0l0,-71.094l47.559,0l0,11.865l-32.91,0l0,16.944l28.125,0z`}
          id="4"
        />
        <path
          d={`m${
            405.42 + letterSpace * 5
          },0l0,71.094l-14.649,0l-28.515,-46.778l0,46.778l-14.649,0l0,-71.094l14.649,0l28.564,46.875l0,-46.875l14.6,0z`}
          id="5"
        />
        <path
          d={`m${
            470.313 + letterSpace * 6
          },0l0,11.865l-21.778,0l0,59.229l-14.648,0l0,-59.229l-21.485,0l0,-11.865l57.911,0z`}
          id="6"
        />
      </CustomSvgIcon>
    );
  }

  render() {
    const { style } = this.props;

    return (
      <div>
        {/** 테두리는 텍스트에서 상하좌우 1px 더 큰 크기를 가진다. 나중에만든건 아닌것도 있다 확인하자. */}
        {this.getSvg(style)}
      </div>
    );
  }
}

export default TextBrandLogoIcon;
